import { render, staticRenderFns } from "./viewingAs.vue?vue&type=template&id=e38d6aae&scoped=true"
import script from "./viewingAs.vue?vue&type=script&lang=js"
export * from "./viewingAs.vue?vue&type=script&lang=js"
import style0 from "./viewingAs.vue?vue&type=style&index=0&id=e38d6aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38d6aae",
  null
  
)

export default component.exports